export function useCypressAutomation() {
  const generateAutomationTag = (sectionTag: string, componentTag: string, htmlTag?: string): string => {
    return htmlTag ? `${sectionTag}-${componentTag}-${htmlTag}` : `${sectionTag}-${componentTag}`
  }

  return { generateAutomationTag }
}
